import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import {ProfilService} from "../../services/mon-profil/profil.service";
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-mon-profil',
  templateUrl: './mon-profil.component.html',
  styleUrls: ['./mon-profil.component.scss']
})
export class MonProfilComponent implements OnInit {

  constructor(private readonly _: SourceAuthoritesAfterAuthenticationService,protected profilService :ProfilService, private configurationService: ConfigurationService) { }
  configuration=this.configurationService.get().mon_profil;
  config_global=this.configurationService.get();
  public fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);
  ngOnInit(): void {
  }
  handleUpdateFullName($event: any): void {
    const fullName = $event.userEntrepriseResponse?.prenom + " " + $event.userEntrepriseResponse?.nom ;
    this.profilService.updateFullName(fullName);
  }
}
